import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FUNNEL_ADDRESS_STEP, FUNNEL_PAYMENT_SELECTION_STEP } from '../../constants/funnel';
import { HAS_INSTANT_DISCOUNT, USE_PARITY } from '../../constants/ebon';

import {
    doUserCartTotalCashbackAmount,
    doUserCartTotalCashbackAmountParity
} from '../../utils/cartUtils';
import { formatAmountCurrency, formatAmountParity } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import ButtonContainer from './buttons/ButtonContainer';
import AddressSubmitButton from './buttons/AddressSubmitButton';

import './FunnelRightContainerStyle.scss';

const getCountryLabel = (countries, countryCode) => {
    const country = Object.values(countries || {}).find(c => c.value === countryCode);
    return country ? country.label : countryCode;
};

const FunnelRightContainer = ({
    partnerId,
    userInfo,
    userCart,
    stateOfTransaction,
    setStateOfTransaction,
    amountCashback,
    cartTotalValue,
    paymentType,
    kycNeeded,
    i18n,
    COUNTRIES
}) => {
    const getLabelText = () => {
        if (HAS_INSTANT_DISCOUNT) {
            return i18n.EBON_CAGNOTTE_INSTANT_DISCOUNT;
        } else {
            return i18n.EBON_CAGNOTTE;
        }
    };

    return (
        <div id="funnel-right-container">
            <h3>{`${i18n.RECAPITULATIF}`}</h3>
            <div className="rightInnerContainer bordered ebonRecap">
                <h3>{`${i18n.BASKET}`}</h3>
                {userCart.map((ebons, i) => (
                    <div key={i}>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18n.BON_ACHAT_LIGNE,
                                ebons.partnerName,
                                formatAmountCurrency(ebons.value)
                            )}
                        </p>
                        <div style={{ minWidth: '100px' }}>
                            <span>x {ebons.quantity}</span> <span> = </span>{' '}
                            <span
                                style={{
                                    justifyContent: 'flex-end',
                                    flex: 2
                                }}>
                                {formatAmountCurrency(ebons.quantity * ebons.value)}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {userInfo && userInfo.billingAdress && (
                <div className="rightInnerContainer bordered-no-top billingAddress">
                    <h3>{i18n.BILLING_ADDRESS}</h3>
                    <p>{`${userInfo.firstname} ${userInfo.lastname}`}</p>
                    <p>{userInfo.billingAdress}</p>
                    <p>{`${userInfo.billingPostalCode} ${userInfo.billingCity}`}</p>
                    <p>{getCountryLabel(COUNTRIES, userInfo.billingCountry)}</p>
                    <p>{userInfo.phoneNumber}</p>
                </div>
            )}

            <div className="rightInnerContainer bordered-no-top ebonTotal">
                <div className="cashback">
                    <p>{getLabelText()}</p>
                    <div>
                        <span>
                            {USE_PARITY
                                ? formatAmountParity(
                                      doUserCartTotalCashbackAmountParity(userCart, amountCashback)
                                  )
                                : formatAmountCurrency(
                                      doUserCartTotalCashbackAmount(userCart, amountCashback)
                                  )}
                        </span>
                    </div>
                </div>
                <div className="total">
                    <p>{`${i18n.TOTAL_VALUE}`}</p>
                    <div>
                        <span>{formatAmountCurrency(cartTotalValue)}</span>
                    </div>
                </div>
            </div>

            {stateOfTransaction === FUNNEL_ADDRESS_STEP && <AddressSubmitButton />}

            {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && (
                <ButtonContainer
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                    cartTotalValue={cartTotalValue}
                    userInfo={userInfo}
                    partnerId={partnerId}
                    kycNeeded={kycNeeded}
                />
            )}
        </div>
    );
};

FunnelRightContainer.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    userCart: PropTypes.array,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    amountCashback: PropTypes.number,
    cartTotalValue: PropTypes.number,
    paymentType: PropTypes.string,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        COUNTRIES: state.i18n.feature.form.COUNTRIES
    };
};

export default connect(mapStateToProps)(FunnelRightContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelRightContainer.js